const configApp = {
  academyBillingPassword: 'vidroop-facturacion-2026',
  academyDomain: 'https://academia.test.vidroop.com',
  academyUrl: 'vidroop',
  apiKeyTinyMce: 'nmmuxa1oi0rlug1hougubvrgge2hhd73ju9jq5thrlvy62gi',
  apiUrl: 'https://api.test.vidroop.com',
  apiVersion: 'v1',
  appAcademyDomain: 'https://academia.test.vidroop.com',
  appAulaDomain: 'https://aula.test.vidroop.com',
  appDomain: 'https://ventas.test.vidroop.com',
  authCallbackUrl: 'https://ventas.test.vidroop.com/login-callback',
  authClientId: 'pIrpwXQsGgst65LZi5Mwnvgdu1fLnJWL',
  authDomain: 'dev-aws-vidroop.eu.auth0.com',
  marketPlaceDomain: 'https://tienda.test.vidroop.com/academia',
  pdfGeneratorDomain: 'https://pdfgenerator.test.vidroop.com/v1/invoice',
  universityDomain: 'https://aula.test.vidroop.com/login/42497047-90ac-4937-ad69-5438d8464ac7',
  vidroopAcademyUUID: '42497047-90ac-4937-ad69-5438d8464ac7',
  droopEvaluacionHabilitado: true,
  droopInteligenciaArtificialHabilitado: true,
  droopRuletaHabilitado: true
}

export default configApp